import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
  shallowEqual,
} from "react-redux";

import { AppDispatch } from "../redux";
import { RootState } from "../redux/rootReducer";

export const useAppSelector: TypedUseSelectorHook<RootState> = (rest) =>
  useSelector(rest, { equalityFn: shallowEqual });

export const useAppDispatch: () => AppDispatch = useDispatch;
